export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Credentials & Insurance',
      items: [
        'Valid contractor license',
        'General liability insurance',
        'Workers compensation coverage',
        'Professional certifications'
      ]
    },
    {
      category: 'Experience & Portfolio',
      items: [
        'Years in business locally',
        'Portfolio of completed projects',
        'Material expertise and variety',
        'Custom fabrication capabilities'
      ]
    },
    {
      category: 'Services & Pricing',
      items: [
        'Detailed written estimates',
        'Material and labor warranties',
        'Installation timeline',
        'Templating and measurement services'
      ]
    },
    {
      category: 'Quality & Reviews',
      items: [
        'Customer reviews and ratings',
        'Before and after photos',
        'References from past clients',
        'Showroom or material samples'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Countertop Contractor Comparison Checklist
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Use this checklist to evaluate and compare countertop contractors before making your selection.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {checklistItems.map((section, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg border border-amber-100"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-700 text-white rounded-lg">
                  <i className="ri-checkbox-circle-line text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              <ul className="space-y-4">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-amber-700 text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-amber-700 rounded-2xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">
            Ready to Transform Your Kitchen or Bathroom?
          </h3>
          <p className="text-lg mb-6 text-amber-50">
            Get free quotes from multiple licensed countertop contractors and compare materials.
          </p>
          <button className="px-8 py-4 bg-white text-amber-700 font-semibold rounded-lg hover:bg-amber-50 transition-colors whitespace-nowrap">
            Get Free Quotes Now
          </button>
        </div>
      </div>
    </section>
  );
}
